import React, { Component } from "react";
import "antd/dist/reset.css";
// import './TabNew.css';
import { Tabs, Button, DatePicker } from "antd";
import AuthUserList from "./AuthUserList";
import AuthorizationDetails from "./AuthorizationDetails";
import Axios from "axios";
import Config from "../../../src/config";
import { Link, Redirect } from "react-router-dom";
import "../../App.css";
import { authListObject } from "../../store/broadcaster/BroadcastRegister";

const { TabPane } = Tabs;
class NewTab extends Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 0;
    const panes = [
      {
        title: "Auth List",
        content: (
          <div style={{ marginLeft: "0px" }}>
            {" "}
            <AuthUserList
              uniqueId={this.props.uniqueId}
              getAuthData={this.props.getAuthData}
              authTabValue={this.props.authTabValue}
              authTab={this.props.authTab}
              fromPage={this.props.fromPage}
              subId={this.props.subId}
              activetab={this.props.activetab}
              npi={this.props.npi}
              taxId={this.props.taxId}
              getDetails={this.getAdmissionDetails}
              user={this.props.user}
              memberDetails={this.props.memberDetails}
              member={this.props.member}
              tabKey={this.props.tabKey}
              activeKey={this.props.activeKey}
            />
          </div>
        ),
        key: "1",
        closable: false,
      },
      // { title: 'Member Details', content: 'Content of Tab Pane 2', key: '2' },
    ];
    this.state = {
      fromPage: this.props.hereFrom,
      count: 1,
      activeKey: panes[0].key,
      panes,
      TabButtons: null,
      activeTab:
        this.props.activetab === null ||
        this.props.activetab === undefined ||
        this.props.activetab === ""
          ? "1"
          : this.props.activetab,
    };
    // console.log("newtabjs constructor")
  }

  componentDidMount(){
    if(sessionStorage.getItem("planName") === 'solis' && this.state.fromPage === 'sidebar'){
      var windowDimensions = "height="+window.screen.height+",width="+window.screen.width
      this.setState({
        TabButtons:
        <div className="tab-button-container">
          <button onClick={() => {
            window.open(
              Config.OTC,
              "OTC Portal",
              windowDimensions
            );
          }}>OTC Portal</button>
          <button onClick={() => {
            window.open(
              Config.CalypsoLite,
              "Calypso Lite",
              windowDimensions
            );
          }}>Calypso Lyte</button>
          <button onClick={() => {
            window.open(
              Config.EnsureDataSolutions,
              "Ensure Data Solutions",
              windowDimensions
            );
          }}>Ensure Data Solutions</button>
          <button onClick={() => {
            window.open(
              Config.SolisHealthPlan,
              "Solis Health Plan",
              windowDimensions
            );
          }}>Solis Health Plans</button>
        </div>        
      });
    }
  }

  getAdmissionDetails = (user) => {
    this.add(user);
  };

  onChange = (activeKey) => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  add = (user) => {
    //  console.log(user)
    // console.log(AdmissionID)

    const { panes } = this.state;
    var activeKey;
    var currentIndex = this.state.panes.findIndex((pane) =>
      pane.title.includes(user.Reference)
    );

    if (currentIndex === -1) {
      activeKey = `newTab${this.newTabIndex++}`;
      panes.push({
        title: "Ref. ID:" + " " + user.Reference,
        content: <AuthorizationDetails user={user} />,
        key: activeKey,
      });
    } else {
      activeKey = panes[currentIndex].key;
    }
    this.setState({ panes, activeKey });
  };

  remove = (targetKey) => {
    let { activeKey } = this.state;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (panes.length && activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key;
      } else {
        activeKey = panes[0].key;
      }
    }
    this.setState({ panes, activeKey });
  };

  render() {
    this.state.count = this.state.count + 1;
    return (
      <div id="dTable">
        <div>
          <div
            className={
              this.state.activeTab === "1"
                ? "app-body-container"
                : "app-body-container-new"
            }
          >
            <div style={{ marginLeft: "-40px" }}>
              <Tabs
                hideAdd
                tabBarExtraContent= {this.state.TabButtons}
                onChange={this.onChange}
                activeKey={this.state.activeKey}
                type="editable-card"
                onEdit={this.onEdit}
              >
                {this.state.panes.map((pane) => (
                  <TabPane
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    {pane.content}
                  </TabPane>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NewTab;
